<div class="inside-container">
  {{ (label ? label : 'consensus.pas_resultats') | translate }}
</div>
